import { useDispatch, useSelector } from 'react-redux';
import { Radio, Spin, Empty } from 'antd';
import { ShopOutlined, LoadingOutlined } from '@ant-design/icons';
import { shippingActions } from '../../features/shipping';
import { shippingSelectors } from '../../features/shipping';
import { SHIPPING_TYPES } from '../../features/shipping';
import PickupPointsMap from './PickupPointsMap';
import './ShippingOptions.css';

const ShippingOptions = () => {
    const dispatch = useDispatch();

    const isLoading = useSelector(shippingSelectors.selectIsLoading);
    const error = useSelector(shippingSelectors.selectError);
    const selectedOption = useSelector(shippingSelectors.selectSelectedOption);
    const { delivery, pickup } = useSelector(shippingSelectors.selectShippingByType);
    const hasOptions = useSelector(shippingSelectors.selectHasShippingOptions);
    const isPickupSelected = useSelector(shippingSelectors.selectIsPickupSelected);
    const selectedPickupPoint = useSelector(shippingSelectors.selectSelectedPickupPoint);

    const handleSelectOption = (optionKey) => {
        dispatch(shippingActions.setSelectedOption(optionKey));
    };

    if (isLoading) {
        return (
            <div className="shipping-loading">
                <Spin indicator={<LoadingOutlined spin />} />
                <span>Рассчитываем стоимость доставки...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="shipping-error">
                <span>Ошибка расчёта: {error}</span>
            </div>
        );
    }

    if (!hasOptions) {
        return (
            <div className="shipping-empty">
                <Empty
                    description="Укажите адрес для расчёта доставки"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            </div>
        );
    }

    return (
        <div className="shipping-options">
            {pickup.length > 0 && (
                <div className="shipping-group">
                    <div className="shipping-group-title">
                        <ShopOutlined /> Пункты выдачи
                    </div>
                    <Radio.Group
                        value={selectedOption}
                        onChange={(e) => handleSelectOption(e.target.value)}
                        className="shipping-radio-group"
                    >
                        {pickup.map((option) => {
                            const isSelected = selectedOption === option.key;
                            const hasPickupCost = isSelected && selectedPickupPoint?.amount > 0;
                            const displayCost = hasPickupCost ? selectedPickupPoint.amount : option.cost;
                            const displayCostFormatted = hasPickupCost
                                ? `${Math.round(selectedPickupPoint.amount).toLocaleString()}₽`
                                : option.costFormatted;

                            return (
                                <Radio
                                    key={option.key}
                                    value={option.key}
                                    className="shipping-option"
                                >
                                    <div className="shipping-option-content">
                                        <div className="shipping-option-info">
                                            <span className="shipping-method-name">
                                                {option.methodName}
                                            </span>
                                            <span className="shipping-days">
                                                {option.daysFormatted}
                                            </span>
                                        </div>
                                        <span className={`shipping-cost ${displayCost === 0 ? 'free' : ''}`}>
                                            {displayCostFormatted}
                                        </span>
                                    </div>
                                </Radio>
                            );
                        })}
                    </Radio.Group>

                    {isPickupSelected && <PickupPointsMap />}
                </div>
            )}
        </div>
    );
};

export default ShippingOptions;